import axios, { AxiosResponse } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Hashtag } from './types';


export const getHashtagThunk = createAsyncThunk(
    'hastag/getHashtag',
    async (projectId:number, { getState, rejectWithValue, ...thunkApi})=>{
        try{
            const response: AxiosResponse<any> = await axios.get(
                `/hashtag-pools-list/${projectId}`
            )
            return response.data;
        } catch(err){
            return rejectWithValue((err as any).response.data || err)
        }
    }
)


export const addHashtagThunk = createAsyncThunk(
    'hastag/addHashtag',
    async (data:Hashtag, { getState, rejectWithValue, ...thunkApi})=>{
        try{
            const response: AxiosResponse<any> = await axios.post(
                `/add-hashtag-pool`,data
            )
            return response.data;
        } catch(err){
            return rejectWithValue((err as any).response.data || err)
        }
    }
)

export const updateHashtagThunk = createAsyncThunk(
    'hastag/updateHashtag',
    async (data:Hashtag, { getState, rejectWithValue, ...thunkApi})=>{
        try{
            const response: AxiosResponse<any> = await axios.put(
                `/update-hashtag-pool`,data
            )
            return response.data;
        } catch(err){
            return rejectWithValue((err as any).response.data || err)
        }
    }
)


export const deleteHashtagThunk = createAsyncThunk(
    'hastag/deleteHashtag',
    async (id:number, { getState, rejectWithValue, ...thunkApi})=>{
        try{
            const response: AxiosResponse<any> = await axios.delete(
                `/delete-hashtag-pool/${id}`
            )
            return response.data;
        } catch(err){
            return rejectWithValue((err as any).response.data || err)
        }
    }
)


